export default "__VITE_ASSET__HQh6hNZZ__"